import {ComponentFactoryResolver, ComponentRef, Directive, ElementRef, HostListener, Input, ViewContainerRef} from '@angular/core';
import {TooltipContentComponent} from '../components/tooltip/tooltip-content/tooltip-content.component';
import {TooltipService} from '../services/tooltip.service';

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective {

	@Input() appTooltip: any = {};

	private tooltip: ComponentRef<TooltipContentComponent>;

	constructor(private elementRef: ElementRef,
	            private viewContainerRef: ViewContainerRef,
	            private resolver: ComponentFactoryResolver,
	            private tooltipSvc: TooltipService,
  ) {}

	@HostListener('click')
	show(): void {
		this.tooltipSvc.destroy();

		const factory = this.resolver.resolveComponentFactory(TooltipContentComponent);
		this.tooltip = this.viewContainerRef.createComponent(factory);
		this.tooltip.instance.tooltipRef = this.elementRef;
		this.tooltip.instance.tooltipTitle = this.appTooltip.title;
		this.tooltip.instance.tooltipContent = this.appTooltip.content;
		this.tooltip.instance.helpLink = this.appTooltip.help;
		this.tooltip.instance.close.subscribe(() => {
			this.tooltipSvc.destroy();
		});

		this.tooltipSvc.addTooltip(this.tooltip);
	}
}
